"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgWeatherNight = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M29.333 21.126a13.9 13.9 0 0 1-5.742 1.232c-7.704 0-13.95-6.245-13.95-13.95 0-2.046.441-3.99 1.233-5.741-4.84 2.188-8.207 7.06-8.207 12.717 0 7.704 6.245 13.95 13.95 13.95 5.657 0 10.528-3.368 12.716-8.208" }))); };
exports.default = SvgWeatherNight;
//# sourceMappingURL=WeatherNight.js.map